import styled from 'styled-components'

export const TooltipIconWrap = styled.div<{
  hasMarginLeft?: boolean
  hasRightMargin?: boolean
  color?: string
  bgColor?: string
}>`
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  text-align: center;
  border-radius: 16px;
  cursor: pointer;
  background: ${({ bgColor, theme: { palette } }) =>
    bgColor ? bgColor : palette.default};
  color: ${({ color, theme: { palette } }) => (color ? color : palette.muted)};
  margin-left: ${({ hasMarginLeft, theme: { mp } }) => hasMarginLeft && mp.xs};
  margin-right: ${({ hasRightMargin, theme: { mp } }) =>
    hasRightMargin && mp.xs};
`
